"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.default = void 0;
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reselect = require("reselect");
var _injectReducer = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/injectReducer"));
var _baseLayout = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.actions");
var _baseLayout2 = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.constants");
var _baseLayout3 = require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.selectors");
var _baseLayout4 = _interopRequireDefault(require("cornerstone_ui_core/lib/containers/BaseLayout/base-layout.reducer"));
var _Sider = _interopRequireDefault(require("./Sider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const mapDispatchToProps = dispatch => ({
  sideNavToggle: () => {
    dispatch((0, _baseLayout.sideNavToggle)());
  },
  sideNavHide: () => {
    dispatch((0, _baseLayout.sideNavHide)());
  },
  sideNavShow: () => {
    dispatch((0, _baseLayout.sideNavShow)());
  },
  sideNavMenuUpdate: payload => {
    dispatch((0, _baseLayout.sideNavMenuUpdate)(payload));
  },
  getShortcutNavigationOptions: (0, _baseLayout.dispatchService)(dispatch, "getShortcutNavigationOptions")
});
exports.mapDispatchToProps = mapDispatchToProps;
const mapStateToProps = (0, _reselect.createStructuredSelector)({
  isSidenavCollapsed: (0, _baseLayout3.makeSelectIsSidenavCollapsed)(),
  profileImage: (0, _baseLayout3.makeSelectProfileImage)(),
  dept: (0, _baseLayout3.makeSelectDept)(),
  dbMenus: (0, _baseLayout3.makeSelect)("menusFromDB")
});
const withConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);
const withReducer = (0, _injectReducer.default)({
  key: _baseLayout2.key,
  reducer: _baseLayout4.default
});
var _default = exports.default = (0, _redux.compose)(withReducer, withConnect)(_Sider.default);